import PageModelBase from 'Models/Pages/Base/PageModelBase.interface';
import { useKexRouterCurrentPage } from '../../Kex/KexRouter/KexRouter';

export default function useCurrentPage<PageType extends PageModelBase>() {
  return useKexRouterCurrentPage() as PageType;
}
